import { createColumnHelper } from '@tanstack/react-table'
import { useMemo } from 'react'

import { CarrierConnectionExpanded } from '@engine/models'

import { Table } from '#components/Table'

interface CarrierConnectionsListProps {
  credentials: CarrierConnectionExpanded[]
  selectedId?: string
  onSelect: (credential: CarrierConnectionExpanded) => void
}

const columnHelper = createColumnHelper<CarrierConnectionExpanded>()

const CarrierConnectionsList = ({
  credentials,
  selectedId,
  onSelect,
}: CarrierConnectionsListProps) => {
  const columns = useMemo(
    () => [
      columnHelper.display({
        id: 'carrier',
        header: 'Carrier',
        cell: info => {
          const credential = info.row.original
          return (
            <>
              <div className="font-semibold capitalize">
                {credential.carrierCode}
              </div>
              <div className="text-xs opacity-60">{credential._id}</div>
            </>
          )
        },
      }),
      columnHelper.accessor('createdAt', {
        id: 'createdAt',
        header: 'Created At',
      }),
      columnHelper.accessor('accountId', {
        header: 'Account ID',
        cell: info => (
          <>
            <div className="font-semibold capitalize">
              {info.row.original.accountName}
            </div>
            <div className="text-xs opacity-60">{info.getValue()}</div>
          </>
        ),
      }),
      columnHelper.accessor('tenantId', {
        header: 'Tenant ID',
        cell: info => (
          <>
            <div className="font-semibold capitalize">
              {info.row.original.tenantName}
            </div>
            <div className="text-xs opacity-60">{info.getValue()}</div>
          </>
        ),
      }),
    ],
    [],
  )

  return (
    <div className="rounded-box border border-base-300 bg-base-100">
      <Table
        data={credentials}
        columns={columns}
        getRowId={credential => credential._id}
        selectedId={selectedId}
        onRowClick={onSelect}
        className="table table-sm w-full"
      />
    </div>
  )
}

export { CarrierConnectionsList }
